import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c508aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-system" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-system" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "btn-box"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (item.type === _ctx.types.MSG_GRP_TIP || item.type === _ctx.types.MSG_GRP_SYS_NOTICE)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_ctx.translateGroupSystemNotice(item)), 1),
                (item?.payload?.operationType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("button", {
                        class: "btn btn-default",
                        onClick: ($event: any) => (_ctx.handleApplication('Agree', item))
                      }, "接受", 8, _hoisted_5),
                      _createElementVNode("button", {
                        class: "btn btn-cancel",
                        onClick: ($event: any) => (_ctx.handleApplication('Reject', item))
                      }, "拒绝", 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}